module.exports = __webpack_public_path__ + "img/laboratorio3_4-3_1024.ccb1ec1c.jpg";